import { gql } from "@apollo/client";

export const SettingsFragment = gql`
  fragment SettingsFragment on Settings {
    id
    meals
    hiddenMeals
  }
`;

// The organization's settings, or the defaults when it never saved any. Read
// by every screen that lists meals; the cache answers all but the first.
export const get = gql`
  query SettingsGet {
    viewer {
      id
      account {
        id
        settings {
          id
          get {
            ...SettingsFragment
          }
        }
      }
    }
  }
  ${SettingsFragment}
`;

// Answers with the saved settings under the same `settings/<orgId>` id the
// read cached them as, so Apollo replaces them in place and every screen
// reading meals follows without a refetch.
export const save = gql`
  mutation SettingsSave($input: SettingsInput!) {
    viewer {
      account {
        settings {
          save(input: $input) {
            ...SettingsFragment
          }
        }
      }
    }
  }
  ${SettingsFragment}
`;
